import { render, staticRenderFns } from "./PageIndicator.vue?vue&type=template&id=b872bebe&scoped=true&"
import script from "./PageIndicator.vue?vue&type=script&lang=js&"
export * from "./PageIndicator.vue?vue&type=script&lang=js&"
import style0 from "./PageIndicator.vue?vue&type=style&index=0&id=b872bebe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b872bebe",
  null
  
)

export default component.exports